
import { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useCallback } from 'react';
import { useTranslation } from "react-i18next";
import * as Styled from './Accordions.styled';

export type AccordionsProps = {
    sx?: SxProps
    rows: {
        id: string;
        TitleContent: React.JSX.Element;
        Bodycontent: React.JSX.Element;
    }[]
}

export const Accordions: React.FC<AccordionsProps> = ({ rows, sx }) => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = React.useState<string | false>(rows?.[0]?.id || false);

    const handleChangeActiveItem = useCallback(
        (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
            setExpanded(newExpanded ? panel : false);
        }, [])

    return (
        <Box sx={sx}>
            {rows.map((row) => (
                <Styled.Accordion key={row.id} expanded={expanded === row.id} onChange={handleChangeActiveItem(row.id)}>
                    <Styled.AccordionSummary aria-controls={row.id + "-content"} id={row.id + "-header"}>
                        {row.TitleContent}
                        <AnimatePresence initial={false}>
                            <motion.span
                                key={expanded === row.id ? 'hide' : 'show'}
                                initial={{ opacity: 0, x: 8 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -8, display: "none" }}
                                transition={{ duration: 0.5 }}
                                style={{ alignSelf: 'center' }}
                            >
                                <Styled.AccordionSummaryActionLabel>
                                    {expanded === row.id ? t("Accordions.hide") : t("Accordions.show")}
                                </Styled.AccordionSummaryActionLabel>
                            </motion.span>
                        </AnimatePresence>
                    </Styled.AccordionSummary>
                    <Styled.AccordionDetails>
                        {row.Bodycontent}
                    </Styled.AccordionDetails>
                </Styled.Accordion>
            ))}
        </Box>
    );
}